export const KPICard = ({ icon: Icon, label, value, hint, accent = 'cyan' }) => {
    const colorMap = {
        cyan: 'bg-[hsl(var(--kche-cyan))]/10 text-[hsl(var(--kche-cyan))]',
        yellow: 'bg-[hsl(var(--kche-yellow))]/15 text-[hsl(var(--kche-yellow))]',
        green: 'bg-[hsl(var(--kche-green))]/10 text-[hsl(var(--kche-green))]',
        pink: 'bg-[hsl(var(--kche-pink))]/10 text-[hsl(var(--kche-pink))]',
        blue: 'bg-[hsl(var(--kche-blue))]/10 text-[hsl(var(--kche-blue))]',
    };
    return (
        <div data-testid="admin-kpi-card" className="rounded-2xl bg-white border border-border p-5 shadow-[var(--shadow-soft)] flex flex-col gap-3">
            <div className="flex items-center justify-between">
                <span className="text-xs font-medium uppercase tracking-wider text-muted-foreground">{label}</span>
                {Icon ? <span className={`size-9 rounded-xl inline-flex items-center justify-center ${colorMap[accent]}`}><Icon className="size-4" /></span> : null}
            </div>
            <div className="text-3xl font-display font-bold tabular-nums">{value ?? 0}</div>
            {hint ? <div className="text-xs text-muted-foreground">{hint}</div> : null}
        </div>
    );
};

export default KPICard;
